import { baseURL } from "../../util/Constant";
import { getFalsePrintFile, getFalseSewnFile } from "../redux/falsePrint";
import { getMessage } from "../redux/messageSlice";
import { getAllPrintFile, getAllRipsForChart, loading } from "../redux/printSlice";
export let image;

//Get All Print FIle
export const getAllPrintFileFetch = () => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/print/getAll`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      //console.log(data);
      dispatch(getAllPrintFile(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Get False Print FIle
export const getFalsePrintFileFetch = () => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/print/getPrint`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      //console.log(data);
      
      if (data.errorCode || data.status) {
        dispatch(getMessage(data.message));
        return;
      }
      dispatch(getFalsePrintFile(data));
      
    })
    .catch((error) => {
      console.log(error);
    });
};

//Get False Sewn FIle
export const getFalseSewnFileFetch = () => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/print/getSewn`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode || data.status) {
        dispatch(getMessage(data.message));
        return;
      }
        dispatch(getFalseSewnFile(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Change print:false => true
export const putUpdatePrintFileFetch = (id, folderFabric, fileName) => async (dispatch) => {
  try {
    const response = await fetch(`${baseURL}/print/update`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, folderFabric, fileName }),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    throw error;
  }
};


//Change sewn:false => true
export const putUpdateSewnFileFetch = (id, workers, line, number ) => (dispatch) => {
  
  dispatch(loading(false));
  try {
   fetch(`${baseURL}/sewing/updateSewn`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({id, workers, line, number }),
    });

  } catch (error) {
    console.error('Error updating sewn status:', error);
    throw error;
  }
 };
 
//Get All Rips For Chart
export const getAllRipsForChartFetch = () => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/print/getAllRipsForChart`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      //console.log(data);
      dispatch(getAllRipsForChart(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Update Sewing
// export const putUpdateSewing = (id, number, order, selectedWorkers) =>(dispatch) => {
//   dispatch(loading(false));
//   try {
//    fetch(`${baseURL}/print/updateSewing`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ id, number, order, selectedWorkers }),
//     });

//   } catch (error) {
//     console.error('Error updating sewing:', error);
//     throw error;
//   }
// };
